/* eslint-disable complexity */
import React from 'react';
import {Marker, Overlay} from '@homeaway/react-google-maps';
import {MapHit} from '../MapHit/MapHit';
import {APP_NAMES} from '../../constants';
import {useMapContext, useTrackingContext} from '../../context/MapContext';
import {EDAP_EVENTS, triggerEdapEventWithContext} from '../../utils/edapHelper';
import OverlayContent from '../OverlayContent/OverlayContent';

const BaseMarker = (props) => {
    const mapContext = useMapContext();
    const trackingContext = useTrackingContext();

    const {
        infoWindowOptions,
        isSelected,
        index,
        isHighlighted,
        hoveredMarker,
        onClick,
        pinType,
        ...rest
    } = props;

    const showOverlay = () => {
        switch (mapContext.appName) {
            case APP_NAMES.SERP:
                return (
                    isSelected && infoWindowOptions && infoWindowOptions.images
                );
            case APP_NAMES.LANDINGAPP:
                return (
                    ((isSelected && (isHighlighted || !hoveredMarker)) ||
                        isHighlighted) &&
                    infoWindowOptions &&
                    infoWindowOptions.content
                );
            case APP_NAMES.PDP:
                return props.name && isSelected;
            default:
                return (
                    (isSelected || isHighlighted) &&
                    infoWindowOptions &&
                    infoWindowOptions.content
                );
        }
    };
    const {pixelOffset, infoBoxClearance, ...mapHitProps} =
        infoWindowOptions || {};

    const getContent = () => {
        switch (mapContext.appName) {
            case APP_NAMES.SERP:
                return (
                    <MapHit infoWindowOptions={mapHitProps} hitIndex={index} />
                );

            case APP_NAMES.PDP:
                return <OverlayContent {...rest} />;
            default:
                return (
                    <div className="BaseMarker-Overlay-content">
                        {infoWindowOptions.content}
                    </div>
                );
        }
    };

    const renderOverlayContent = () => {
        return showOverlay() ? (
            <Overlay
                pixelOffset={pixelOffset}
                infoBoxClearance={infoBoxClearance}
                alignBottom={mapContext.appName === APP_NAMES.SERP}
                boxStyle={
                    mapContext.appName === APP_NAMES.SERP
                        ? {
                              overflow: 'visible',
                          }
                        : {}
                }
            >
                {getContent()}
            </Overlay>
        ) : null;
    };
    return (
        <Marker
            {...rest}
            onClick={() => {
                triggerEdapEventWithContext(
                    trackingContext,
                    EDAP_EVENTS.MAP_PIN_SELECTED,
                    {
                        action_location: mapContext.appName,
                        pin_type: pinType,
                    }
                );
                onClick();
            }}
        >
            {renderOverlayContent()}
        </Marker>
    );
};

export default BaseMarker;
